export class RegulationsModel {
  constructor (regulationsData = {}) {
    this.id = regulationsData.id
    this.title = regulationsData.title
    this.content = regulationsData.content
    this.files = regulationsData.files
  }
}
